export default {
  custom_option: 'Mukautettu',
  zero_option: 'Ei tippiä',
};
